<template>
  <div class="pr-3 content-center" :class="{ 'opacity-50': running }">
    <svg
      v-if="result"
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.144043" width="56" height="56" rx="28" fill="#F3EEEC" />
      <rect x="11.7891" y="11.9336" width="32.4211" height="32.4211" rx="16.2105" fill="#14B8A6" />
      <path
        d="M24.7951 31.875L20.6251 27.705L19.2051 29.115L24.7951 34.705L36.7951 22.705L35.3851 21.295L24.7951 31.875Z"
        fill="white"
      />
    </svg>
    <svg
      v-else
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="-0.00842285" width="56" height="56" rx="28" fill="#F3EEEC" />
      <rect x="11.7891" y="11.7811" width="32.4211" height="32.4211" rx="16.2105" fill="#FF5C26" />
      <path
        d="M18 35.0545L27.2692 16L36.5385 35.0545H18ZM19.7192 33.8636H34.8193L27.2692 18.3818L19.7192 33.8636ZM27.2692 32.2148C27.4436 32.2148 27.5898 32.1446 27.7078 32.004C27.8258 31.8635 27.8847 31.6894 27.8847 31.4818C27.8847 31.2742 27.8258 31.1001 27.7078 30.9596C27.5898 30.8191 27.4436 30.7488 27.2692 30.7488C27.0949 30.7488 26.9487 30.8191 26.8307 30.9596C26.7127 31.1001 26.6538 31.2742 26.6538 31.4818C26.6538 31.6894 26.7127 31.8635 26.8307 32.004C26.9487 32.1446 27.0949 32.2148 27.2692 32.2148ZM26.7692 29.5579H27.7692V23.6034H26.7692V29.5579Z"
        fill="white"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Boolean,
      default: true,
    },
    running: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
